import type { Account } from '@/api/types'

/** ISO date desc, nullish last (most-recently-active first). */
function compareByLastActiveDesc(a: Account, b: Account): number {
  const av = a.lastActive ?? ''
  const bv = b.lastActive ?? ''
  if (!av && !bv) return 0
  if (!av) return 1
  if (!bv) return -1
  return bv.localeCompare(av)
}

/**
 * The order the picker lists workspaces in: whatever the user touched last,
 * first. Copies rather than sorting in place — the array comes from the query
 * cache, which nothing outside TanStack may mutate.
 */
export function sortAccounts(accounts: Account[]): Account[] {
  return [...accounts].sort(compareByLastActiveDesc)
}
